/**
 * One DoseSpot launch surface open at a time, process-wide.
 *
 * DoseSpot keys the prescribing frame's patient context on an `SSOPatientId`
 * cookie scoped to the **top-level site**, not to the iframe — so two open
 * prescribing frames in one BeHuman tab share one patient context and can
 * prescribe into the wrong chart. Mantine's overlay already makes the second
 * click impossible in one direction (the Prescribe modal covers the header, so
 * the notification bell is unreachable); the other direction — the shell-level
 * notifications frame open, navigate to a chart, click Prescribe — has no
 * overlay in the way and needs this guard.
 *
 * A module-level holder rather than context: the two surfaces are mounted in
 * different trees (the patient chart's action bar and the app shell) and only
 * ever need the answer at click time, so there is nothing to subscribe to.
 */
let holder: string | null = null

/**
 * Takes the launch slot for `claimant` (a component-stable id). Returns false
 * when another surface holds it — the caller must not open.
 */
export function claimDoseSpotLaunch(claimant: string): boolean {
  if (holder !== null && holder !== claimant) return false
  holder = claimant
  return true
}

/** Releases the slot, if this claimant holds it. Safe to call unconditionally. */
export function releaseDoseSpotLaunch(claimant: string): void {
  if (holder === claimant) holder = null
}
